// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 14.2136L11.984 14.2026C11.5596 13.9101 11.1379 13.6194 10.7395 13.2916C10.3386 12.9616 9.80183 12.4839 9.26196 11.8934C8.2179 10.7514 7 9.01215 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.01233 15.7821 10.7515 14.738 11.8935C14.1981 12.484 13.6614 12.9617 13.2604 13.2917C12.8621 13.6195 12.4403 13.9101 12.0159 14.2026L12 14.2136ZM13.5 7C13.5 6.17157 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5C12.8284 8.5 13.5 7.82843 13.5 7Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M7.00008 10H3.10503L1.88281 21H22.1173L20.8951 10H17.0001V12H19.105L19.8828 19H4.11734L4.89512 12H7.00008V10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-map-information-2-filled')
export default class MapInformation2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-information-2-filled',
    }
  }
}
